import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendUser } from 'src/types/backend';

const QUERY = gql`
  query ChannelsAuthState {
    me {
      id
      googleData {
        authState
      }
      facebookData {
        authState
      }
      metaAdsData {
        authState
      }
      linkedinData {
        authState
      }
      linkedinSocialData {
        authState
      }
      hubspotData {
        authState
      }
      salesforceData {
        authState
      }
      twitterSocialData {
        authState
      }
    }
  }
`;

export const queryChannelsAuthState = async () => {
  const response = await executeGqlQuery({ query: QUERY });
  const result = getSingleProp<BackendUser>(response.data);
  return {
    googleAuthState: result?.googleData?.authState,
    facebookAuthState: result?.facebookData?.authState,
    metaAdsAuthState: result?.metaAdsData?.authState,
    linkedinAuthState: result?.linkedinData?.authState,
    linkedinSocialAuthState: result?.linkedinSocialData?.authState,
    hubspotAuthState: result?.hubspotData?.authState,
    salesforceData: result?.salesforceData?.authState,
    twitterSocialData: result?.twitterSocialData?.authState,
  };
};
